import store from '../store';
import { clearUser } from '../actions/user';
import { clearToken } from '../actions/requestToken';

export const SignOutClearStore = () => {
  localStorage.removeItem('stakeholder');
  localStorage.removeItem('profile');

  let stateData = JSON.parse(localStorage.getItem('state'));
  store.dispatch(clearUser());
  store.dispatch(clearToken());
  stateData = {
    ...stateData,
    user: {},
    requestToken: { barearToken: '', refreshToken: '' },
  };
  localStorage.setItem('state', JSON.stringify(stateData));
};
